// removed by extract-text-webpack-plugin
module.exports = {"creditLogo":"BGAsset__creditLogo___22HkX","creditSteps":"BGAsset__creditSteps___OxPfo","creditLineBreak":"BGAsset__creditLineBreak___1ggVk","credit":"BGAsset__credit___2NY_z","success":"BGAsset__success___2c8pg","icon1":"BGAsset__icon1___1kBuk","icon2":"BGAsset__icon2___3mguQ","icon3":"BGAsset__icon3___22H2e","merchant":"BGAsset__merchant___NznBs","confirmBank":"BGAsset__confirmBank___2hGdS"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/BGAsset.less
 ** module id = 752
 ** module chunks = 0
 **/